import { LegalPage } from "./LegalPage";
import { LEGAL } from "@/lib/legal";

export default function AvisoLegal() {
  return (
    <LegalPage title="Aviso legal">
      <h2>Identidad del prestador del servicio</h2>
      <ul>
        <li><strong>Razón social:</strong> {LEGAL.legalName}</li>
        <li><strong>País de residencia fiscal:</strong> {LEGAL.country}</li>
        <li><strong>Email de contacto:</strong> <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a></li>
        <li><strong>Dominio web:</strong> {LEGAL.domain}</li>
      </ul>

      <h2>Objeto</h2>
      <p>
        El presente aviso legal regula el acceso, navegación y uso del sitio web <a href={`https://${LEGAL.domain}`}>{LEGAL.domain}</a>, así como las responsabilidades derivadas de la utilización de sus contenidos.
      </p>

      <h2>Condiciones de uso</h2>
      <p>
        El usuario se compromete a hacer un uso adecuado y lícito del sitio web. Para los usuarios registrados, el uso de la aplicación se rige por los <a href="/terminos">Términos y condiciones</a>.
      </p>

      <h2>Propiedad intelectual e industrial</h2>
      <p>
        Todos los contenidos del sitio web (textos, gráficos, código, imágenes, marca {LEGAL.brand}) son propiedad de {LEGAL.legalName} salvo indicación expresa. Queda prohibida su reproducción total o parcial sin autorización previa por escrito.
      </p>

      <h2>Exención de responsabilidad</h2>
      <p>
        {LEGAL.legalName} no se hace responsable de los daños o perjuicios derivados del uso o imposibilidad de uso del sitio web, ni de los contenidos generados por la inteligencia artificial. El usuario es responsable de revisar y validar las ofertas, análisis y propuestas antes de utilizarlas comercialmente.
      </p>

      <h2>Enlaces a terceros</h2>
      <p>
        El sitio puede contener enlaces a sitios web de terceros. {LEGAL.legalName} no controla ni se responsabiliza del contenido de esos sitios.
      </p>

      <h2>Modificaciones</h2>
      <p>
        {LEGAL.legalName} se reserva el derecho a modificar este aviso legal en cualquier momento. La fecha de vigencia que aparece arriba refleja siempre la última versión.
      </p>

      <h2>Legislación aplicable</h2>
      <p>
        Este aviso legal se rige por la legislación de {LEGAL.country}.
      </p>
    </LegalPage>
  );
}
